export const TEST_ID_TOURIST_OPTION_CANCEL_DELETE =
  'TEST_ID_TOURIST_OPTION_CANCEL_DELETE';

export const TEST_ID_TOURIST_OPTION_CONFIRM_DELETE =
  'TEST_ID_TOURIST_OPTION_CONFIRM_DELETE';
